import script from "./FavoriteButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoriteButton.vue?vue&type=script&setup=true&lang=ts"

import "./FavoriteButton.vue?vue&type=style&index=0&id=cd94218a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd94218a"]])

export default __exports__